import {
  ADD_ADMIN_REQUEST,
  UPDATE_ADMIN_REQUEST,
  DELETE_ADMIN_REQUEST,
  GET_ADMIN_REQUEST,
  GET_REMAINING_ADMIN_REQUEST,
} from "../type";
import { InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateAdminRequestAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertDataWithImage(
      `/api/AdministrativeRequest`,
      data
    );
    dispatch({
      type: ADD_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
export const GetAllAdminRequestAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/AdministrativeRequest?${quary}`);
    dispatch({
      type: GET_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
export const GetRemainingAdminRequestAction = (quary) => async (dispatch) => {
  try {
    const respons = await GetDataToken(
      `/api/AdministrativeRequest/GetRemainingForSelectedType?${quary}`
    );
    dispatch({
      type: GET_REMAINING_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_REMAINING_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
export const UpdateAdminRequestAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(
      `/api/AdministrativeRequest/UpdateAdminRequest`,
      body
    );
    dispatch({
      type: UPDATE_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};

export const DeleteAdminRequestAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(
      `/api/AdministrativeRequest/DeleteAdminRequest?id=${Id}`
    );
    dispatch({
      type: DELETE_ADMIN_REQUEST,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_ADMIN_REQUEST,
      payload: "Error" + e,
    });
  }
};
